import { Alert, Drawer } from 'antd'
import React, { useEffect, useState } from 'react'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCubes, faFloppyDisk, faHouse, faMountain, faXmark } from '@fortawesome/free-solid-svg-icons'
import { NavegacaoDrawer } from '../../../recomendacao/novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import { Select } from '../../../../../Components/CustomUi/Select'
import { SelectMulti } from '../../../../../Components/CustomUi/SelectMulti'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'

interface PropsFormulario {
  open: boolean
  fecharGaveta: Function
  permissions: ItensPerUserLogged
  propriedade_selecionada: string
  setPropriedade_selecionada: React.Dispatch<React.SetStateAction<string>>
  setPropriedade_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  calcario_selecionado: string
  calcario_selecionado_id: number
  setCalcario_selecionado: React.Dispatch<React.SetStateAction<string>>
  setCalcario_selecionado_id: React.Dispatch<React.SetStateAction<number>>
  calcario_selecionados: { descr: string; id: number; key?: number }[]
  setCalcario_selecionados: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  calcario_original_id: number
  data_propriedades: any[]
  data_calcarios: any[]
  cadastrarCalcarioPropriedade: Function
  loadingSalvar: boolean
}

export const FormularioCadastroCalcarioPropriedade: React.FC<PropsFormulario> = ({
  open,
  fecharGaveta,
  permissions,
  propriedade_selecionada,
  setPropriedade_selecionada,
  setPropriedade_selecionada_id,
  calcario_selecionado,
  calcario_selecionado_id,
  setCalcario_selecionado,
  setCalcario_selecionado_id,
  calcario_selecionados,
  setCalcario_selecionados,
  calcario_original_id,
  data_propriedades,
  data_calcarios,
  cadastrarCalcarioPropriedade,
  loadingSalvar
}) => {
  const [openPropriedade, setOpenPropriedade] = useState<boolean>(false)
  const [openCalcarioPrincipal, setOpenCalcarioPrincipal] = useState<boolean>(false)
  const [openCalcario, setOpenCalcario] = useState<boolean>(false)

  return (
    <Drawer
      width={500}
      open={open}
      onClose={() => fecharGaveta()}
      closable={false}
      bodyStyle={{ padding: 0 }}
      headerStyle={{ padding: '10px 10px' }}
      destroyOnClose
      footer={
        <div className='footer'>
          <ButtonCustom
            icon={<FontAwesomeIcon icon={faFloppyDisk} />}
            type='primary'
            onClick={cadastrarCalcarioPropriedade}
            loading={loadingSalvar}
            disabled={loadingSalvar || permissions?.acesso === 1}
          >
            Salvar
          </ButtonCustom>
        </div>
      }
      title={
        <NavegacaoDrawer>
          <ButtonCustom
            danger
            icon={<FontAwesomeIcon icon={faXmark} />}
            type='tertiary'
            onClick={fecharGaveta}
            style={{ marginLeft: -10 }}
          >
            Fechar
          </ButtonCustom>
        </NavegacaoDrawer>
      }
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '10px',
          boxSizing: 'border-box',
          gap: 10,
        }}
      >
        <Select
          value={propriedade_selecionada}
          label='Propriedade'
          placeholder='Selecione a propriedade'
          icon={faHouse}
          onChange={setPropriedade_selecionada}
          onChangeID={setPropriedade_selecionada_id}
          open={openPropriedade}
          trigger={setOpenPropriedade}
          items={data_propriedades}
          descricaoItem={'nome'}
          idItem={'cod'}
        />
         <SelectMulti
          label='Calcários'
          placeholder='Seleciones os calcários'
          icon={faCubes}
          open={openCalcario}
          trigger={setOpenCalcario}
          items={data_calcarios}
          descricaoItem={'nome'}
          idItem={'cod'}
          selecteds={calcario_selecionados}
          onChange={setCalcario_selecionados}
          limit={3}
        />
        <Select
          label='Calcário principal'
          value={calcario_selecionado}
          placeholder='Selecione o calcário principal'
          icon={faMountain}
          onChange={setCalcario_selecionado}
          onChangeID={setCalcario_selecionado_id}
          open={openCalcarioPrincipal}
          trigger={setOpenCalcarioPrincipal}
          items={calcario_selecionados}
          descricaoItem={'descr'}
          idItem={'id'}
        />
        {calcario_original_id !== calcario_selecionado_id && calcario_selecionado_id !== null && (
            <>
              <Alert
                message='Aviso'
                description='Caso possua resultados de OS já processados, será necessário reprocessá-los!'
                type='warning'
                showIcon
                // closable
              />
              <br />
            </>
          )}
      </div>
       
    </Drawer>
  )
}